import { render, staticRenderFns } from "./AdministrativeCenters.vue?vue&type=template&id=f09239e8&scoped=true"
import script from "./AdministrativeCenters.vue?vue&type=script&lang=js"
export * from "./AdministrativeCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09239e8",
  null
  
)

export default component.exports